<script>
  import dialogStore from './store.js'
</script>

{#if $dialogStore !== null}
<div class="dialogLayer">
  <div class="dialog">
    <div class="header">{$dialogStore.header}</div>
    <div class="body">
      <p class="message">
        {$dialogStore.message}
      </p>
      <div class="actions">
        <span class="spacer"></span>
        {#each $dialogStore.actions as action (action.name)}
          <button on:click={action.action}>{action.name}</button>
        {/each}
      </div>
    </div>
  </div>
</div>
{/if}

<style>
  div.dialogLayer {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
    padding: 10px;

    background-color: #FFF8;
  }

  div.dialog {
    min-width: 150px;
    max-width: 100%;

    background-color: white;
    border-radius: 10px;
    box-shadow: 0 0 10px #0004;
  }

  div.dialog .header {
    padding: 15px;
    border-bottom: 1px solid var(--border-color);

    font-weight: 500;
  }

  div.dialog .body {
    padding: 15px;
  }
  div.dialog .body .message {
    margin-bottom: 15px;

    text-align: center;
  }

  div.dialog .body .actions {
    display: flex;
  }
  div.dialog .body .actions > button {
    flex-shrink: 0;

    margin-right: 15px;
  }
  div.dialog .body .actions > button:last-child {
    margin-right: 0;
  }

  @media only screen and (min-width: 450px) and (min-height: 550px) {
    div.dialogLayer {
      padding: 30px;
    }
    div.dialog {
      max-width: 400px;
    }
  }
</style>
